/**
 * 총판공지사항 등록 폼데이터
 */
export class FormDataDistributorNotice {
    _id = '';
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    _title = '';
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    _body = '';
    get body() {
        return this._body;
    }
    set body(value) {
        this._body = value;
    }
    // 도메인 데이터를 받아서 폼데이터로 치환
    constructor(data) {
        if (!data) {
            return;
        }
        // 여기서 domain-model을 form에 맞게 변경
        Object.assign(this, data);
    }
}
